import { db, currentUser } from './firebase'

const defaultSettings = {
  messageEmail: true,
}

export const fetchSettings = () =>
  db
    .ref(`user-settings/${currentUser()}`)
    .once('value')
    .then(snapshot => snapshot.val())
    .then(
      settings =>
        settings
          ? Object.keys(defaultSettings).reduce(
              (result, prop) => ({
                ...result,
                [prop]:
                  settings[prop] === undefined
                    ? defaultSettings[prop]
                    : settings[prop],
              }),
              {}
            )
          : defaultSettings
    )

export const updateSettings = settings =>
  db.ref(`user-settings/${currentUser()}`).set(settings)



// WEBPACK FOOTER //
// ./src/api/settings.js